import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiService } from './api.service';
import { ApiUrl } from './apiUrl';
import { saveBlobAsFile } from './file-download.util';

@Injectable({
  providedIn: 'root'
})
export class GlobalProductService {

  constructor(private api: ApiService) {}

  listPlatformProducts(filters?: any) {
    let url = ApiUrl.globalProducts;
    if (filters) {
      const params = new URLSearchParams(filters).toString();
      if (params) url = `${url}?${params}`;
    }
    return this.api.getRequest(url);
  }

  listChainProducts(chainId: string, filters?: any) {
    let url = ApiUrl.globalProductsByChain(chainId);
    if (filters) {
      const params = new URLSearchParams(filters).toString();
      if (params) url = `${url}?${params}`;
    }
    return this.api.getRequest(url);
  }

  getGlobalProduct(id: string) {
    return this.api.getRequest(ApiUrl.globalProductById(id));
  }

  createGlobalProduct(data: any) {
    return this.api.postRequest(ApiUrl.globalProducts, data);
  }

  createChainGlobalProduct(chainId: string, data: any) {
    return this.api.postRequest(ApiUrl.globalProductsByChain(chainId), data);
  }

  updateGlobalProduct(id: string, data: any) {
    return this.api.putRequest(ApiUrl.globalProductById(id), data);
  }

  deleteGlobalProduct(id: string) {
    return this.api.deletRequest(ApiUrl.globalProductById(id));
  }

  forceSync(id: string) {
    return this.api.postRequest(ApiUrl.globalProductSync(id), {});
  }

  getLinkedProducts(id: string) {
    return this.api.getRequest(ApiUrl.globalProductLinkedProducts(id));
  }

  linkProductToGlobal(storeId: string, productId: string, globalProductId: string) {
    return this.api.postRequest(ApiUrl.linkProductToGlobal(storeId, productId), { globalProductId });
  }

  unlinkProduct(storeId: string, productId: string) {
    return this.api.deletRequest(ApiUrl.unlinkProductFromGlobal(storeId, productId));
  }

  updateFieldLocks(storeId: string, productId: string, fieldLocks: Record<string, boolean>) {
    return this.api.patchRequest(ApiUrl.updateProductFieldLocks(storeId, productId), { fieldLocks });
  }

  importPlatformCSV(formData: FormData) {
    return this.api.postRequest('global-products/import', formData);
  }

  importChainCSV(chainId: string, formData: FormData) {
    return this.api.postRequest(`global-products/chain/${chainId}/import`, formData);
  }

  downloadTemplate(): Observable<void> {
    return this.api.getBlobRequest(ApiUrl.globalProductsImportTemplate).pipe(
      tap((blob) => saveBlobAsFile(blob, 'global-products-template.csv')),
      map(() => undefined)
    );
  }
}
